import "./utils/sentry";
import { Analytics } from "@vercel/analytics/react";
import { Toaster } from "react-hot-toast";
import Approach from "./components/Approach";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Path from "./components/Path";
import Projects from "./components/Projects";
import Stack from "./components/Stack";
import Ticker from "./components/Ticker";

function App() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-paper text-ink-950">
      <Header />

      <main>
        <Hero />
        <Ticker />
        {/* Work leads — everything after it is supporting evidence */}
        <Projects />
        <Approach />
        <Stack />
        <Path />
        <Contact />
      </main>

      <Footer />

      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#373228",
            color: "#F5F1E8",
            border: "1px solid #484236",
            fontSize: "0.875rem",
          },
        }}
      />

      {/* Vercel Web Analytics — cookie-free, ~2KB, no-op outside a Vercel
          deployment with analytics enabled in the dashboard. */}
      {process.env.NODE_ENV === "production" && <Analytics />}
    </div>
  );
}

export default App;
